module.exports = __webpack_public_path__ + "static/img/LXWM-33.ff6e9b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/base/LXWM-33.jpg
// module id = 9OZV
// module chunks = 1